import { render, staticRenderFns } from "./CertificateRequestDone.vue?vue&type=template&id=9da45c64&scoped=true"
import script from "./CertificateRequestDone.vue?vue&type=script&lang=js"
export * from "./CertificateRequestDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da45c64",
  null
  
)

export default component.exports